var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function () { return ({
    components: {
        MuiFormLabel: {
            defaultProps: {
                // MUI _does_ allow setting the component prop on FormLabel, TS is just not properly configured to know it here in default props
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                component: 'legend',
            },
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextSmall), { color: designTokens.color.gray.slateDefault.value, '&.Mui-focused:not(.Mui-error)': {
                        color: designTokens.color.gray.slateDefault.value,
                    } }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formLabelTheme.js.map